import {config as globalConfig} from '../../../config';

const config = {
    steps: [
        {
            id: 1,
            title: "renewal.stepper.id",
            link: "/renewal",
            status: 'active'
        },
        {
            id: 2,
            title: "renewal.stepper.vehicleDetails",
            link: ["/renewal/home", "/renewal/vehicle-driver-info"],
            status: 'next'
        },
        {
            id: 3,
            title: "renewal.stepper.payment",
            link: "/renewal/payment",
            status: 'pending'
        },
    ],
    paymentSuccessRedirect: `${globalConfig.redirectDomainUrl}/renewal/success`,
    paymentFailedRedirect: `${globalConfig.redirectDomainUrl}/renewal`,
    paymentSuccessKitCredit: `${globalConfig.redirectDomainUrl}/renewal/kit/credit`,
    paymentSuccessKitSadad: `/renewal/kit/sadad`,
    // paymentSuccessRedirect: "/renewal/summary",
    // paymentFailedRedirect: "/renewal/failed",
    sadadSuccessRedirect: "/renewal/success",
    allowedPriceDetails: ["TOTC", "PLFEE", "PRMA", "CLMA", "NCD", "LDS", "CAPD", "DRVA", "VTBL", "VAT", "VATP"],
    priceTranslations: {
        "TOTC": "vehicle-value",
        "PLFEE": "motor-policy-fee",
        "CLMA": "motor-claim-loading",
        "LDS": "motor-loyalty-discount",
        "NCD": "motor-no-claim-discount",
        "VATP": "motor-vat-percentage",
        "VAT": "motor-vat-amount",
        "PRMA": "motor-promo-discount",
        "DRVA": "vitality-drive-discount",
        "VTBL": "vtbl-amount"
    },
};

export default config;